import axios from 'axios';
import {delCookie, getCookie} from "../utils/util";
import {Message} from "element-ui";
import router from "../router";
import {saveAs} from 'file-saver';

const baseUrl = '/api';
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        const code = res.data.code || 200;
        const msg = res.data.msg || '系统未知错误,请反馈给管理员'
        if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject(res.data);
        } else {
            return res.data
        }
    });
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: getCookie('access_token')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        const code = res.data.code || 200;
        const msg = res.data.msg || '系统未知错误,请反馈给管理员'
        if (code === 401) {
            // 清除token并重定向到登录页
            delCookie('access_token');
            router.push({path: '/login'})
            return Promise.reject(new Error(msg))
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject(res.data);
        } else {
            return res.data
        }
    });
};


// 通用下载方法
const download = (url, params, filename, callFun) => {
    return axios({
        method: 'post',
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: getCookie('access_token')
        },
        timeout: 300000,
        responseType: 'blob',
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then((res) => {
        const blob = new Blob([res.data]);
        saveAs(blob, filename);
    })
}

export {
    loginreq,
    req,
    download
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js